import { gql } from "@apollo/client";


export const DELETE_SECTION_LOCATION = gql`
  mutation DeleteSection($domain: String!, $sectionId: Int!) {
    section {
      delete(domain: $domain, sectionId: $sectionId) {
        code
        success
        message
        deletionResults {
          deletedSection
          deletedLocations
          deletedTerminals
        }
      }
    }
  }
`

export interface DeleteSectionResponse {
  section: {
    delete: {
      code: string
      success: boolean
      message: string
      deletionResults: {
        deletedSection: number
        deletedLocations: number[]
        deletedTerminals: number[]
      }
    }
  }
}